import { ActivityCategory, PageCategory, PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { showConfirmationModal } from "mds/components/Modal";
import { isArchived } from "utils/activity";
import { isUnassessableCategory } from "utils/page-utils";

export const destinationShouldUnpublish = (
  destination: { activityCategory: ActivityCategory } | { pageCategory: PageCategory },
): boolean => {
  if ("activityCategory" in destination) {
    return isArchived(destination.activityCategory);
  }

  return isUnassessableCategory(destination.pageCategory);
};

export const isArchivedDestination = (
  destination: { activityCategory: ActivityCategory } | { pageCategory: PageCategory },
): destination is { activityCategory: ActivityCategory } =>
  "activityCategory" in destination && isArchived(destination.activityCategory);

export async function maybeConfirmUnpublishOnMove(
  page: Pick<PageType, "assessments_published_at" | "released_at">,
  destination: { activityCategory: ActivityCategory } | { pageCategory: PageCategory },
): Promise<boolean> {
  if (!destinationShouldUnpublish(destination)) {
    return true;
  }

  if (page.assessments_published_at) {
    return showConfirmationModal({
      title: t("unpublish_on_move_modal.title"),
      labelText: t("unpublish_on_move_modal.description"),
      confirmButtonText: t("unpublish_on_move_modal.confirm"),
      isWarningLabel: true,
    });
  }

  if (isArchivedDestination(destination)) {
    return showConfirmationModal({
      title: t("unpublish_page_on_move_modal.title"),
      labelText: t("unpublish_page_on_move_modal.description"),
      confirmButtonText: t("unpublish_page_on_move_modal.confirm"),
      isWarningLabel: true,
    });
  }

  return true;
}
